interface CardContainerProps {
  children: React.ReactNode;
  className?: string;
  padding?: string;
  onClick?: () => void;
}

export const CardContainer = ({
  children,
  className = '',
  padding = 'p-6',
  onClick,
}: CardContainerProps) => {
  return (
    <div
      className={`rounded-xl bg-white ${padding} shadow-[0_4px_12px_0_rgba(0,0,0,0.05)] border border-slate-100 ${className}`}
      onClick={onClick}
    >
      {children}
    </div>
  );
};
